import React, { FC } from 'react'
import { ButtonProps, Button as ChakraButton, useTheme } from '@chakra-ui/react'
import { motion } from 'framer-motion'

import type { NucbaTheme } from '../../../styles'
import type { BasicComponentProps } from '../../../common/types'

const Button: FC<BasicComponentProps<ButtonProps>> = ({
  children,
  ...rest
}) => {
  const { colors } = useTheme<NucbaTheme>()

  return (
    <ChakraButton
      as={motion.button}
      whileTap={{ scale: 0.95 }}
      fontSize='xl'
      paddingInline={9}
      paddingBlock={2}
      bg={colors.nucba.primary}
      _hover={{
        bg: colors.nucba.primaryHover,
      }}
      _active={{
        bg: colors.nucba.primaryHover,
      }}
      _disabled={{
        bg: '#B40845',
        cursor: 'not-allowed',
      }}
      {...rest}
    >
      {children}
    </ChakraButton>
  )
}

export default Button
